import AthleteTrivia from "../components/AthleteTrivia";

const choices = [
  { number: 'A', answer: 'Georgia', correct: false },
  { number: 'B', answer: 'Ohio State', correct: true },
  { number: 'C', answer: 'Oregon', correct: false },
  { number: 'D', answer: 'Alabama', correct: false }
]
const question = 'Where did Marvin play college football?'
const message = 'Marvin went to Ohio State where he amassed 2,671 yards and 32 touchdowns.'


const TriviaMarvin = () => {
  return (
    <AthleteTrivia 
      athlete_name={'Marvin'}
      closet_path={'/marvin-closet'}
      video_path={'marvin/marvin_quiz.mp4'}
      question_id={2}
      choices={choices}
      question={question}
      message={message}
    />
  )
}
export default TriviaMarvin;
